import axios from "@/plugins/axios.js";
import store from "@/store";
import Cookies from "js-cookie";
// states
export const state = {
  info: null,
  storeIdAdmin: Cookies.get("store-id-admin")
    ? JSON.parse(Cookies.get("store-id-admin"))
    : null,
  menu: null,
  online: {
    status: null,
    message: "",
  },
};

// mutations
export const mutations = {
  SET_STORE_INFO: (state, data) => {
    state.info = data;
  },
  SET_STORE_ID_ADMIN: (state, data) => {
    Cookies.set("store-id-admin", data, { expires: 365 });
    state.storeIdAdmin = data;
  },
  SET_STORE_ID: (state, data) => {
    Cookies.set("store-id", data, { expires: 365 });
    state.storeId = data;
  },
  SET_STORE_INFO_DELETE: (state) => {
    Cookies.remove("store-id-admin");
    state.storeIdAdmin = null;
    state.storeId = null;
    state.info = null;
  },
  SET_STORE_MENU: (state, data) => {
    state.menu = data;
  },
  SET_STORE_ONLINE: (state, data) => {
    state.online = data;
  },
};

// actions
export const actions = {
  setStoreInfo({ commit }, payload) {
    store.dispatch("loading/start");
    commit("SET_STORE_INFO", payload);
    store.dispatch("loading/done");
  },
  setStoreId({ commit }, payload) {
    commit("SET_STORE_ID", payload);
  },
  setStoreIdAdmin({ commit }, payload) {
    commit("SET_STORE_ID_ADMIN", payload);
  },
  delete({ commit }, payload) {
    commit("SET_STORE_INFO_DELETE", payload);
  },
  async loadStoreInfoAdmin({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get(
      "/app/stores/" + store.getters.storeIdAdmin
    );
    commit("SET_STORE_INFO", data.data);
    store.dispatch("loading/done");
  },
  async loadStoreMenu({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get(
      "/app/store/" + store.getters.storeInfo.id + "/productcategories"
    );
    commit("SET_STORE_MENU", data.data);
    store.dispatch("loading/done");
  },
  setStoreOnline({ commit }, payload) {
    commit("SET_STORE_ONLINE", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
